var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

var wheelOpt = { passive: false };
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
function disableScroll() {
  window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
  window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

window.scrollTo(0, 0);

// window.onbeforeunload = function() {
//   window.scrollTo(0, 0);
// };
$(function() {
  $('.chapter-circle').popover({
    container: '.chapter-nav-popover-holder',
    placement: 'right'
  });
})

const aos = require('aos');

const vid = document.querySelector('video');
vid.playbackRate = 3;
vid.currentTime = 0;
vid.pause();
$(window).one("scroll", function(e) {
  e.preventDefault();
  window.scrollTo(0, 0);
  vid.play();
  disableScroll();
  $('#intro-1').remove();
  $('#intro-2').show();
  $('body').css({
    "padding-bottom": "1px"
  })
})

aos.init({
  once: true,
});

